import { NavLink } from "react-router-dom";
import './UnderNavigation.scss';
import {ReactComponent as Icon1} from '../../../Assets/Icons/undernav1.svg';
import {ReactComponent as Icon2} from '../../../Assets/Icons/smartphone.svg';
import {ReactComponent as Icon3} from '../../../Assets/Icons/undernav3.svg';
import {ReactComponent as Icon4} from '../../../Assets/Icons/undernav4.svg';
import {ReactComponent as Icon5} from '../../../Assets/Icons/undernav5.svg';
import {ReactComponent as Icon6} from '../../../Assets/Icons/undernav6.svg';


export function UnderNavigation() {
    return (
      <section
        className='under-navigation'
      >
        <div className='container'>
         
            <NavLink
              exact
              to='/desktop'
              activeClassName='is-active'
              className='under-navigation__item'
            >
            <div className="navcontent">

              <Icon1 />
      
             
              <span className='under-navigation__text'>Desktop</span>
             
              </div>
              </NavLink>
              <NavLink
              exact
              to='/android-phone'
              activeClassName='is-active'
              className='under-navigation__item'
            >
              <div className="navcontent">
              <Icon2 />
              <span className='under-navigation__text'>Android Phone</span>
            </div>
            </NavLink>
            <NavLink
              exact
              to='/android-pad'
              activeClassName='is-active'
              className='under-navigation__item'
            >
            <div className="navcontent">
            <Icon3 />
  
              <span className='under-navigation__text'>Android Tablet</span>
            </div>
            </NavLink>
            <NavLink
              exact
              to='/imac-app'
              activeClassName='is-active'
              className='under-navigation__item'
            >
            <div className="navcontent">
            <Icon4 />
              <span className='under-navigation__text'>iMac</span>
            </div>
            </NavLink>
            <NavLink
              exact
              to='/mobile-app'
              activeClassName='is-active'
              className='under-navigation__item'
            >
            <div className="navcontent">
            <Icon5 />
              <span className='under-navigation__text'>iPhone</span>
            </div>
            </NavLink>
            <NavLink
              exact
              to='/ipad-app'
              activeClassName='is-active'
              className='under-navigation__item'
            >
            <div className="navcontent">
            <Icon6 />
              <span className='under-navigation__text'>iPad</span>
          </div>
          </NavLink>
          </div>
       
      </section>
    );
  }